import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableMultiSelect } from '@shared/components/SearchableMultiSelect';
import type { LlmProviderDto } from '@shared/services/apiService/apiService';

type SelectLlmProvidersInputProps = {
  providers: LlmProviderDto[] | undefined;
  selectedIds: string[];
  onChange: (nextIds: string[]) => void;
  disabled?: boolean;
  portalDropdown?: boolean;
};

function providerMatchesQuery(provider: LlmProviderDto, query: string) {
  const title = provider.title.toLowerCase();
  const key = (provider.key || '').toLowerCase();
  return title.includes(query) || key.includes(query);
}

export const SelectLlmProvidersInput: React.FC<SelectLlmProvidersInputProps> = ({
  providers,
  selectedIds,
  onChange,
  disabled,
  portalDropdown = false,
}) => {
  const { t } = useTranslation();

  return (
    <SearchableMultiSelect
      items={providers}
      selectedIds={selectedIds}
      onChange={onChange}
      disabled={disabled}
      portalDropdown={portalDropdown}
      listboxId="select-llm-providers-listbox"
      getLabel={(provider) => provider.title}
      getBadge={(provider) => provider.key}
      matchesQuery={providerMatchesQuery}
      placeholder={t('superAdminMainPage.companies.selectLlmProvidersInput.placeholder')}
      emptyLabel={t('superAdminMainPage.companies.selectLlmProvidersInput.empty')}
      getRemoveLabel={(name) =>
        t('superAdminMainPage.companies.selectLlmProvidersInput.removeProvider', { name })
      }
    />
  );
};
